import React from "react";
import "./style.css";

const Card = ({ className = null, children, style, ...res }) => {
  const _class = className ? `card ${className}` : `card`;
  const _classD = className ? `cardD ${className}` : `cardD`;

  return (
    <div
      className={navigator.userAgent.match(/samsung/i) ? _classD : _class}
      style={style}
      {...res}
    >
      {children}
    </div>
  );
};

export default Card;
